import React from 'react'
import RowItemBus from '../row-item-bus/row-item-bus'

const ListRowFirst: React.FunctionComponent = () => {
  return (
    <>
      <RowItemBus row1={'banios'} row2={null} row3={null} row4={null} row5={'escaleras'} />
      <RowItemBus row1={1} row2={2} row3={'tv'} row4={null} row5={4} />
      <RowItemBus row1={1} row2={2} row3={null} row4={null} row5={3} />
      <RowItemBus row1={1} row2={2} row3={null} row4={null} row5={3} />
      <RowItemBus row1={1} row2={2} row3={null} row4={null} row5={3} />
    </>
  )
}

export default ListRowFirst